export const calculateTimeForLegend = (minutes: number, estimatedRegularMinutes: number) => {
  const time = {
    regular: 0,
    overtime: 0,
    remaining: 0,
  }

  if (minutes > estimatedRegularMinutes) {
    time.regular = estimatedRegularMinutes
    time.overtime = minutes - estimatedRegularMinutes
  } else if (minutes === estimatedRegularMinutes) {
    time.regular = estimatedRegularMinutes
  } else {
    time.regular = minutes
    time.remaining = estimatedRegularMinutes - minutes
  }

  return time
}
